import { render, staticRenderFns } from "./IconBack.vue?vue&type=template&id=5ab7b4f4&"
import script from "./IconBack.vue?vue&type=script&lang=js&"
export * from "./IconBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports